interface Props {
  text: 'DEMO' | 'REVOKED' | 'EXPIRED' | 'DRAFT' | string;
}

const COLORS: Record<string, string> = {
  DEMO: 'text-gray-300',
  REVOKED: 'text-red-200',
  EXPIRED: 'text-amber-200',
  DRAFT: 'text-blue-200',
};

export default function DocumentWatermark({ text }: Props) {
  return (
    <div className="a4-watermark absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden z-10">
      <p className={`text-[80px] font-black tracking-[0.2em] rotate-[-35deg] opacity-25 select-none ${COLORS[text] || 'text-gray-300'}`}>
        {text}
      </p>
    </div>
  );
}
